module.exports = __webpack_public_path__ + "media/images/faces/face9-542b49f35f013fe90734f8693113125f.jpg";